import { IViewMode, MediaItem, TimelineDataItem, TreeItem, ViewModeType } from './types';

export interface Cache {
  [id: string]: { startDate: Date; endDate: Date; viewModeType: ViewModeType; items: TimelineDataItem[] };
}

const innerCache: Cache = {};

export const getDataItemsForMedia = (
  startDate: Date,
  endDate: Date,
  viewMode: IViewMode,
  treeItem: TreeItem,
  mediaItem: MediaItem,
  cache: Cache = innerCache
): TimelineDataItem[] => {
  if (cache[treeItem.treeId]) {
    const cacheItem = cache[treeItem.treeId];
    if (
      cacheItem.startDate === startDate &&
      cacheItem.endDate === endDate &&
      cacheItem.viewModeType === viewMode.type
    ) {
      return cacheItem.items;
    }
  }
  const items = viewMode.applyToMedia(mediaItem, treeItem);
  cache[treeItem.treeId] = {
    startDate,
    endDate,
    viewModeType: viewMode.type,
    items
  };
  return items;
};



// WEBPACK FOOTER //
// ./src/store/timelineDataCache.ts